import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWallet = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 35,
	height: 26,
	viewBox: "0 0 35 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M34.014 16.3759H18.1235V13.2071H34.014V16.3759ZM29.3859 25.0608H0.939288V4.81704H14.0486L9.78977 7.69095H5.45148C5.19307 7.69095 4.98269 7.90134 4.98269 8.15975C4.98269 8.42147 5.19307 8.63186 5.45148 8.63186H25.8593H29.3859V12.2695H17.6547C17.393 12.2695 17.1843 12.4782 17.1843 12.7383V16.8463C17.1843 17.1047 17.393 17.3151 17.6547 17.3151H29.3859V25.0608ZM21.193 1.12637L23.1609 4.48405L23.2769 4.68447L25.0393 7.69095H11.4661L21.193 1.12637ZM29.3859 4.81704V7.69095H26.1276L24.443 4.81704H29.3859ZM34.4828 12.2695H30.3235V4.34824C30.3235 4.08818 30.1131 3.87945 29.8547 3.87945H23.893L21.7495 0.221943L21.4497 0L21.082 0.0695591L15.3655 3.92911L15.1617 3.87945H0.470494C0.210427 3.87945 0 4.08818 0 4.34824V25.5312C0 25.7896 0.210427 26 0.470494 26H29.8547C30.1131 26 30.3235 25.7896 30.3235 25.5312V17.3151H34.4828C34.7412 17.3151 34.9516 17.1047 34.9516 16.8463V12.7383C34.9516 12.4782 34.7412 12.2695 34.4828 12.2695Z",
		fill: "#272525"
	})
});
export { SvgWallet as ReactComponent };
